import { getOptionFunc } from '../state';
import { getThemeColor } from './get-theme-color';
export const getApplicationSwitcherIcon = (options) => {
    const getOption = getOptionFunc(options);
    const iconSizePx = getOption('iconSizePx');
    const fill = getThemeColor(options);
    return `<svg height="${iconSizePx}" width="${iconSizePx}" viewBox="0 0 ${iconSizePx} ${iconSizePx}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Group</title>
        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="PrimaryNav" transform="translate(-868.000000, -16.000000)" fill-rule="nonzero">
                <g id="Group-3" transform="translate(869.000000, 14.000000)">
                    <g id="Group" transform="translate(0.000000, 3.500000)">
                        <circle id="Oval" stroke="${fill}" stroke-width="1.5" cx="12" cy="12" r="12"></circle>
                        <rect id="Rectangle-Copy-4" fill="${fill}" x="6" y="6" width="5" height="5"></rect>
                        <rect id="Rectangle-Copy-5" fill="${fill}" x="6" y="13" width="5" height="5"></rect>
                        <rect id="Rectangle-Copy-6" fill="${fill}" x="13" y="6" width="5" height="5"></rect>
                        <rect id="Rectangle-Copy-7" fill="${fill}" x="13" y="13" width="5" height="5"></rect>
                    </g>
                </g>
            </g>
        </g>
    </svg>`;
};
